import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { IncidentDetailsFillState } from '@mobile/views/Relation/DetailsPanel/enums'

import { getHandballIncidentDetailsFillState } from '../utils'

export function getIncidentDetailsFillState(incident: ProbableIncident): {
  state: IncidentDetailsFillState
} {
  return getHandballIncidentDetailsFillState(incident, {
    checkGoalkeeper: true,
  })
}
